<template>
  <div>
    <draggable
      class="dragArea"
      tag="ul"
      :list="children"
      :group="{ name: 'g1' }"
    >
      <li
        v-for="(el, index) in children"
        :key="`${el.id}-${el.name}-${index}`"
        class="no-style mt-1"
      >
        <!-- View mode    -->
        <v-row v-if="!el.edit">
          <v-col v-if="el.color" cols="1">
            <div class="circle" :style="{ backgroundColor: el.color }">
              {{ el.label }}
            </div>
          </v-col>
          <v-col :cols="el.color ? 11 : 12"
            ><h2 :class="computedSize" class="mb-0 text-h6">
              {{ getName(el) }} <span v-if="el.spotlight"> *</span>
            </h2>
          </v-col>

          <v-col
            v-if="attrs.details && el.categories.length"
            cols="6"
            class="pb-0 pt-0"
          >
            <article>
              <p class="text-caption text-uppercase mb-1">Categories</p>
              <div class="d-flex flex-wrap">
                <v-chip
                  v-for="(tag, index) in el.categories"
                  light
                  :key="
                    `tag-nested-category-${tag}-${depthInc}-${index}-${el.id}`
                  "
                  small
                  class="mr-1 mb-1 yellow lighten-3"
                >
                  {{ tag }}</v-chip
                >
              </div>
            </article>
          </v-col>
          <v-col
            v-if="attrs.details && el.assets.length"
            cols="4"
            class="pb-0 pt-0"
          >
            <article>
              <p class="text-caption text-uppercase mb-1 mt-1">Assets</p>
              <div class="d-flex flex-wrap">
                <v-chip
                  v-for="(tag, index) in el.assets"
                  light
                  :key="`tag-nested-asset-${tag}-${depthInc}-${index}-${el.id}`"
                  small
                  class="mr-1 mb-1 green lighten-4"
                >
                  {{ tag }}</v-chip
                >
              </div>
            </article>
          </v-col>

          <v-col v-if="attrs.details && el.brand" cols="4" class="pb-0 pt-0">
            <article>
              <p class="text-caption text-uppercase mb-1 mt-1">Brand</p>
              <div class="d-flex flex-wrap">
                <v-chip small light class="mr-1 mb-1 yellow-lighten-5">
                  {{ el.brand }}</v-chip
                >
              </div>
            </article>
          </v-col>

          <v-col v-if="attrs.details && el.endorsed" cols="4" class="pb-0 pt-0">
            <article>
              <p class="text-caption text-uppercase mb-1 mt-1">Endorsement</p>
              <div class="d-flex flex-wrap">
                <v-chip small light class="mr-1 mb-1 yellow-lighten-5">
                  {{ el.endorsed }}</v-chip
                >
              </div>
            </article>
          </v-col>

          <v-col
            v-if="attrs.details && el.websites.length"
            cols="4"
            class="pb-0 pt-0"
          >
            <article>
              <p class="text-caption text-uppercase mb-1 mt-1">Websites</p>
              <div class="d-flex flex-wrap">
                <v-chip
                  v-for="(tag, index) in el.websites"
                  :key="
                    `tag-nested-asset-website-${tag}-${depthInc}-${index}-${el.id}`
                  "
                  small
                  light
                  class="mr-1 mb-1 yellow-lighten-5"
                >
                  {{ tag }}</v-chip
                >
              </div>
            </article>
          </v-col>

          <v-col v-if="attrs.details && el.body" cols="12">
            <p class="text-caption text-uppercase mb-1 mt-1">Description</p>
            <div class="pre-wrap" v-html="el.body"></div>
          </v-col>
        </v-row>
        <!-- Edit mode    -->
        <v-row v-if="el.edit">
          <v-col cols="2">
            <div class="circle" :style="{ backgroundColor: el.color }">
              {{ el.label }}
            </div>
          </v-col>
          <v-col cols="10">
            <ItemForm
              :key="`${newItem.id}-${el.id}`"
              :new-item="newItem"
              :colors="colors"
              :local="local"
              :attrs="attrs"
              @submit="editCommit"
              @cancel="cancelEdit"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div
              v-if="attrs.controls"
              class="d-flex justify-end align-center flex-wrap pr-4"
            >
              <v-btn @click="editItem(el)" x-small color="white" class="" light
                >Edit</v-btn
              >
              <v-btn
                @click="cloneItem(el)"
                x-small
                color="white"
                class="ml-2"
                light
                >Clone</v-btn
              >

              <v-btn
                class="ml-2"
                @click="deleteItem(el)"
                x-small
                color="white"
                light
                >Delete</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <div v-if="!hideChildren">
          <NestedDraggable
            :children="el.children"
            :attrs="attrs"
            :local="local"
            :depth="depthInc"
            :color="el.color"
            :label="el.label"
          />
        </div>
      </li>
    </draggable>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >

        <v-card-actions>
          <v-btn color="amber" text @click="deleteConfirm">
            Yes
          </v-btn>
          <v-btn color="amber" text @click="deleteCancel">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ItemForm from "@/views/user/exercises/name-system/ItemForm";

import { checkPopulated } from "@/utils/types";

import { itemModel, colors, initialState } from "./model";

export default {
  name: "NestedDraggable",
  data() {
    return {
      edit: false,
      newItem: {
        ...itemModel,
      },
      dialog: false,
      // newName: "",
      // newColor: "",
      // newBody: "",
      // newLabel: "",
      // newPrefix: false,
      // newSpotlight: false,
      depthInc: this.depth + 1,
      colors: colors,
    };
  },
  components: {
    draggable,
    ItemForm,
  },
  props: {
    children: {
      required: true,
      type: Array,
      default: () => [],
    },
    hideChildren: {
      type: Boolean,
      default: false,
    },
    attrs: Object,
    local: Object,
    depth: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedSize() {
      if (this.attrs.type === "large") {
        return "text-h5";
      }
      if (this.attrs.type === "medium") {
        return "text-h6";
      }
      if (this.attrs.type === "small") {
        return "text-body-1";
      }
      if (this.attrs.type === "waterfall") {
        switch (this.depthInc) {
          case 1:
            return "text-h5";
          case 2:
            return "text-h6";
          case 3:
            return "text-body-1";
          default:
            return "text-body-2";
        }
      }
      return "text-h5";
    },
  },
  methods: {
    getName(el) {
      if (this.attrs.prefix && el.allowPrefix) {
        switch (this.attrs.prefixPosition) {
          case "after":
            return `${el.name}${this.attrs.prefix}`;
          case "after-space":
            return `${el.name} ${this.attrs.prefix}`;
          case "before":
            return `${this.attrs.prefix}${el.name}`;
          case "before-space":
            return `${this.attrs.prefix} ${el.name}`;
        }
      } else {
        return el.name;
      }
    },
    getButtonText(el) {
      return el.allowPrefix ? "Prefix on" : "Prefix off";
    },
    getButtonClass(el) {
      return el.allowPrefix ? "white" : "grey lighten-2";
    },
    editItem($event) {
      const pick = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(pick);
      this.$set(this.children, indexOfItem, pick);
      // first reset
      Object.assign(this.newItem, initialState());
      // then make = to event
      Object.assign(this.newItem, { ...$event });
      this.$nextTick(() => {
        pick.edit = true;
      });
    },
    editCommit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = this.constructItem(itemModel, $event);
      editedItem.edit = false;
      this.$set(this.children, indexOfItem, editedItem);
    },
    deleteItem($event) {
      this.dialog = true;
      this.candidate = $event;
    },
    deleteCancel() {
      this.dialog = false;
      this.candidate = false;
    },
    deleteConfirm() {
      const item = this.children.find((x) => x.id === this.candidate.id);
      const indexOfItem = this.children.indexOf(item);
      this.children.splice(indexOfItem, 1);
      this.candidate = null;
      this.dialog = false;
    },
    cancelEdit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = {
        ...item,
        edit: false,
      };
      this.$set(this.children, indexOfItem, editedItem);
    },
    cloneItem($event) {
      const item = { ...this.children.find((x) => x.id === $event.id) };
      item.id = new Date().valueOf();
      item.edit = false;
      const clonedItem = this.constructItem(itemModel, item);
      this.children.push(clonedItem);
    },
    constructItem(model, item) {
      const obj = {};
      Object.keys(model).forEach((key) => {
        obj[key] = checkPopulated(item[key]);
      });
      return obj;
    },
    destroyProto() {
      // console.log("destroy proto");
      // this.newItem = { ...itemModel };
      // this.newItem.motivations.length = 0;
      // this.newItem.categories.length = 0;
      // this.newItem.children.length = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 30px;
  height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}
.pre-wrap {
  white-space: pre-wrap;
}
.dragArea {
  min-height: 2rem;
  // border: 1px dotted #333333;

  li {
    list-style: none;
    background: white;
    padding-left: 1rem;
    background: white;
    margin: 0px 0 0px 0;
    background: rgb(240, 240, 240);
    padding-right: 0rem;
    cursor: pointer;
    border-top: white 1px dotted;
    border-left: white 4px solid;
    ul {
      li {
        background: rgb(230, 230, 230);
        ul {
          margin-bottom: 0px;
          li {
            background: rgb(220, 220, 220);
          }
          ul {
            li {
              background: rgb(210, 210, 210);
            }
            ul {
              li {
                background: rgb(200, 200, 200);
              }
              ul {
                li {
                  background: rgb(190, 190, 190);
                }
              }
            }
          }
        }
      }
    }
  }
  padding: 0;
  margin: 0px;
  margin-bottom: 0.5rem;
}
</style>
